export const settingObject = {};
